import utils from '../utils'
import apiClient from './AxiosHttp'

const getBrands = () => {
    return apiClient.get(`/products/brands/`)
}

const getModels = () => {
    return apiClient.get(`/products/models/`)
}

const getProducts = (params) => {
    return apiClient.get(`/products/list/${params}`)
}

const getProduct = (id) => {
    return apiClient.get(`/products/get/${id}/`)
}

const getProductMedia = (id) => {
    return apiClient.get(`/products/media/${id}/`)
}

const getProductTypes = () => {
    return apiClient.get(`/products/types/`)
}


const addProductType = (data) => {
    return apiClient.post(
        `/dashboard/product/type/list/`,
        data,
        { headers: utils.multipartHeader }
    )
}

const addProductMedia = (id, data) => {
    return apiClient.post(
        `/products/media/${id}/upload/`,
        data,
        { headers: utils.multipartHeader }
    )
}

const deleteProductMedia = (id, data) => {
    return apiClient.post(
        `/products/media/${id}/delete/`,
        data,
    )
}

const addProductModel = (data) => {
    return apiClient.post(`/dashboard/product/model/list/create/`, data)
}

const addBrand = (data) => {
    return apiClient.post(`/dashboard/product/brand/list/create/`, data)
}

const deleteBrand = (id) => {
    return apiClient.delete(`/dashboard/product/brand/get/${id}/`)
}

const deleteModel = (id) => {
    return apiClient.delete(`/dashboard/product/model/get/${id}/`)
}

const productServices = {
    getBrands,
    getModels,
    getProducts,
    getProductTypes,
    getProduct,
    getProductMedia,
    addProductType,
    addProductModel,
    addBrand,
    deleteBrand,
    deleteModel,
    addProductMedia,
    deleteProductMedia,
}

export default productServices